import {
  cilApplicationsSettings,
  cilDrop,
  cilPuzzle,
  cilMoon,
  cilSpeedometer,
  cilSun,
  cilBell,
  cilUserFollow,
  cilUserUnfollow,
  cilChartPie,
  cilBasket,
  cilEnvelopeClosed,
  cilWarning,
  cilEnvelopeOpen,
  cilTask,
  cilCommentSquare,
  cilUser,
  cilSettings,
  cilDollar,
  cilFile,
  cilShieldAlt,
  cilLockLocked,
  cilList,
  cilSpeech,
  cilCalendar,
  cilLocationPin,
  cibSkype,
  cilHome,
  cilNotes,
  cilMagnifyingGlass,
  cilPencil,
  cilTrash,
  cilCloudDownload,
  cilCircle,
  cilScreenDesktop,
  cilBarChart,
  cilPeople,
  cilPowerStandby,
  cilReload,
  cilLoopCircular,
  cilCalendarCheck,
  cilAudio,
  cilVolumeHigh,
  cilVolumeLow,
  cilVolumeOff,
  cilMinus,
  cilPlus,
  cilMicrophone,
  cilAccountLogout,
  cilDevices,
  cibOvercast,
  cilShare,
  cilBook,
  cilVoiceOverRecord,
  cilBullhorn,
  cilHd,
  cilArrowTop,
  cilArrowBottom,
  cilJustifyLeft,
  cilJustifyCenter,
  cilAirplay
} from '@coreui/icons'
import { logo } from './logo'

export const iconsSet = Object.assign({}, {
  cilHd,
  cilJustifyLeft,
  cilJustifyCenter,
  cilArrowTop,
  cilArrowBottom,
  cilBullhorn,
  cilApplicationsSettings,
  cilDrop,
  cilPuzzle,
  cilMoon,
  cilSpeedometer,
  cilSun,
  cilBell,
  cilUserFollow,
  cilUserUnfollow,
  cilChartPie,
  cilBasket,
  cilEnvelopeClosed,
  cilWarning,
  cilEnvelopeOpen,
  cilTask,
  cilCommentSquare,
  cilUser,
  cilSettings,
  cilDollar,
  cilFile,
  cilShieldAlt,
  cilLockLocked,
  cilList,
  cilSpeech,
  cilCalendar,
  cilLocationPin,
  cibSkype,
  cilHome,
  cilNotes,
  cilMagnifyingGlass,
  cilPencil,
  cilTrash,
  cilCloudDownload,
  cilCircle,
  cilScreenDesktop,
  cilBarChart,
  cilPeople,
  cilPowerStandby,
  cilReload,
  cilLoopCircular,
  cilAudio,
  cilCalendarCheck,
  cilVolumeHigh,
  cilVolumeLow,
  cilVolumeOff,
  cilMinus,
  cilPlus,
  cilDevices,
  cilMicrophone,
  cilAccountLogout,
  logo,
  cibOvercast,
  cilShare,
  cilBook,
  cilVoiceOverRecord,
  cilAirplay
})
